import React from 'react';

/**
 * Displays seconds trimmed of leading zero time parts.
 * Examples:
 * 0s -> "0"
 * 5s -> "5"
 * 65s -> "1:05"
 * 3605s -> "1:00:05"
 * 0:00:05 -> "5"
 */
const DurationDisplay = ({ seconds }) => {
  var text = DurationDisplayText({ seconds });
  return <span aria-label={`${text}`}>{text}</span>;
};

export const DurationDisplayText = ({ seconds }) => {
  // Discard any fractional part (no rounding up)
  const total = Math.floor(Number(seconds) || 0);

  const hrs = Math.floor(total / 3600);
  const mins = Math.floor((total % 3600) / 60);
  const secs = total % 60;

  const parts = [hrs, mins, secs];
  let start = 0;
  while (start < parts.length - 1 && parts[start] === 0) start++;

  let text;
  if (start === 2) {
    text = String(parts[2]);
  } else {
    const display = parts.slice(start);
    text = display
      .map((val, idx) => (idx === 0 ? String(val) : String(val).padStart(2, '0')))
      .join(':');
  }
  return text;
};

export default DurationDisplay;